// useImageLoader.js
import { useState, useEffect } from 'react';

export default function useImageLoader(url, fallbackUrl) {
  const [src, setSrc] = useState(url);

  useEffect(() => {
    const img = new Image();
    img.src = url;

    img.onload = () => {
      setSrc(url);
    };

    img.onerror = () => {
      setSrc(fallbackUrl);
    };

    return () => {
      // Чистим обработчики, чтобы избежать memory leaks
      img.onload = null;
      img.onerror = null;
    };
  }, [url, fallbackUrl]);

  return src;
}